'use client'
import { createContext } from 'react';

import { DEFAULT_VALUE_OTP } from './otp/otp.constant';
import { OTPInputType } from './otp/otp.type';
import { DEFAULT_VALUE_POST_ENQUIRY } from './post-enquiry/post-enquiry.constant';
import {
    R123EnquiryContextType,
    R123EnquiryCookiesDataType,
} from './r123-enquiry.type';

const R123EnquiryContext = createContext<R123EnquiryContextType>({
    action: {
        enquiry: {
            setTypeCTAEnquiry: (): void => undefined,
            onChangeBulkEnquiryOnboarding: (): void => undefined,
            onChangeSelectedPhoneNumber: (): void => undefined,
            onClickBantuJual: (): void => undefined,
            onClickBulkButtonEnquiryFavorite: (): void => undefined,
            onClickCoBroke: (): void => undefined,
            onClickPhone: (): void => undefined,
            onClickWhatsapp: (): void => undefined,
            onLoadPropertyRecommendation: (): Promise<
                any[] // PropertyRecommendationEnquiryModel
            > => {
                return new Promise((resolve) => resolve([]));
            },
            onPropertyEnquiredFromRecommendation: (): void => undefined,
            onSubmitEnquiry: (): void => undefined,
            registerEnquiryItem: (): void => undefined,
            toggleDownloadAble: (): void => undefined,
            toggleEnquiryResponse: (): void => undefined,
            toggleFormDialog: (): void => undefined,
        },
        otp: {
            getCurrentState: (): R123EnquiryCookiesDataType | undefined =>
                undefined,
            onChangeField: (): void => undefined,
            onChangeOTPPhoneNumber: (): void => undefined,
            onResendOTP: (): Promise<void> => {
                return new Promise((): void => undefined);
            },
            onSubmitOTPAccountForm: (): Promise<void> => {
                return new Promise((): void => undefined);
            },
            onSubmitOTPAccountFormBulkOriginID: (): Promise<void> => {
                return new Promise((): void => undefined);
            },
            onSubmitOTPNumberForm: (): Promise<OTPInputType> => {
                return new Promise((resolve) => resolve({ success: false }));
            },
            onSubmitOTPNumberFormBulkOriginID: (): Promise<OTPInputType> => {
                return new Promise((resolve) => resolve({ success: false }));
            },
            setAccountFormState: (): void => undefined,
            setAlertState: (): void => undefined,
            setCurrentState: (): void => undefined,
            setEnquiryTypeState: (): void => undefined,
        },
        postEnquiry: {
            onChangeField: (): void => undefined,
            onChangeStorage: (): void => undefined,
            onSendBulkInquiry: (): void => undefined,
        },
    },
    data: {
        enquiry: {
            typeCTAEnquiry: '',
            enquiryForm: {
                buyerEmail: '',
                buyerName: '',
                buyerTelephone: '',
            },
            enquiryItem: [],
            enquiryPlacement: undefined,
            enquiryResponse: {
                showDialog: false,
                type: 'failed',
            },
            enquiryTemp: undefined,
            selectedPhoneNumber: '',
            showFormDialog: false,
        },
        otp: DEFAULT_VALUE_OTP,
        postEnquiry: DEFAULT_VALUE_POST_ENQUIRY,
    },
});

export default R123EnquiryContext;
